import 'css-chunk:src/actionBlock/actionBlock.module.scss';export default {
  "heading-xxl": "actionBlock-module__heading-xxl___4EJK6",
  "wrapper": "actionBlock-module__wrapper___fjO-t",
  "heading-xl": "actionBlock-module__heading-xl___Z1TaN",
  "heading-lg": "actionBlock-module__heading-lg___QNuAy",
  "heading-md": "actionBlock-module__heading-md___3nJ9H",
  "heading-sm": "actionBlock-module__heading-sm___YN7mq",
  "heading-xs": "actionBlock-module__heading-xs___aRDaN",
  "body-one": "actionBlock-module__body-one___WsNpA",
  "body-two": "actionBlock-module__body-two___g3b3d",
  "body-three": "actionBlock-module__body-three___-ma8-",
  "body-four": "actionBlock-module__body-four___ZYsE-",
  "overline-one": "actionBlock-module__overline-one___9Xl1V",
  "overline-two": "actionBlock-module__overline-two___NmQ92",
  "overline-three": "actionBlock-module__overline-three___onqKz",
  "strong": "actionBlock-module__strong___erOYY",
  "em": "actionBlock-module__em___qb3sJ",
  "figcaption": "actionBlock-module__figcaption___D0irG",
  "no-margin": "actionBlock-module__no-margin___noOwd",
  "actionBlock": "actionBlock-module__actionBlock___IQmSz",
  "overline": "actionBlock-module__overline___AdGy0",
  "tag": "actionBlock-module__tag___EJVcB",
  "buttonWrapper": "actionBlock-module__buttonWrapper___vpuMb",
  "actionBlock-background-primary": "actionBlock-module__actionBlock-background-primary___BipFg",
  "actionBlock-background-secondary": "actionBlock-module__actionBlock-background-secondary___p-rHC",
  "oneColumn": "actionBlock-module__oneColumn___riSOL",
  "fullWidth": "actionBlock-module__fullWidth___zMsR8"
};